export default function DisclaimerPanel() {
  return (
    <section className="py-12 md:py-16" style={{ backgroundColor: '#FCEEE5' }} data-testid="landing-disclaimer">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-2xl font-extrabold mb-4" style={{ color: '#5B2D1F' }}>
          Not a substitute for medical advice
        </h2>
        <p className="text-base leading-relaxed" style={{ color: '#6B4A3A' }}>
          Heritage Compass is an educational tool. It is not medical advice, diagnosis,
          or treatment, and is not HIPAA-certified for clinical use. Always consult your
          doctor or pharmacist before making changes to your medication regimen.
        </p>
      </div>
    </section>
  );
}
